<template>
  <div id="pdf" style="width: 100%;height: 100%;">
  </div>
</template>

<script>
import Pdfh5 from 'pdfh5'
import 'pdfh5/css/pdfh5.css'

function getRequest(parName) {
  const str = parName + '='
  let gvalue = ''
  const HREF = location.href
  if (HREF.indexOf(str) > 0) {
    gvalue = HREF.substring(HREF.indexOf(str) + str.length, HREF.length)
    if (gvalue.indexOf('&') > 0) gvalue = gvalue.substring(0, gvalue.indexOf('&'))
    if (gvalue.indexOf('#') > 0) gvalue = gvalue.split('#')[0]
    gvalue = decodeURIComponent(gvalue)
  }
  return gvalue
}

export default {
  name: 'index',
  data() {
    return {
      iframeSrc: ''
      //  /download/casefile/2023-02-24/548678204353.pdf
    }
  },
  created() {
    this.iframeSrc = getRequest('pdf')
  },
  mounted() {
    setTimeout(() => {
      this.pdfh5 = new Pdfh5('#pdf', { pdfurl: this.iframeSrc, goto: 1 })
      this.pdfh5.on('ready', function () {
        console.log('总页数:' + this.totalNum)
      })
      // 监听pdf加载完成事件，加载失败、渲染成功都会触发
      this.pdfh5.on('complete', (status, msg, time) => {
        console.log('状态:' + status + '，信息:' + msg + '，耗时:' + time + '毫秒')
      })
    }, 500)
  }
}
</script>

<style scoped>
  iframe {
    width: 100%;
    height: 100%;
  }
</style>
